import {
  Component,
  Input,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

import { SharedService } from 'app/services/shared.service';
import { environment } from 'environments/environment';
import { SmartMoveThemeService } from '../shell/services/smartmove-theme.service';
@Component({
  selector: 'fuse-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FuseNavbarComponent implements OnDestroy {
  private fusePerfectScrollbar: FusePerfectScrollbarDirective;
  app_version: string = environment.version;
  @ViewChild(FusePerfectScrollbarDirective, { static: true }) set directive(
    theDirective: FusePerfectScrollbarDirective
  ) {
    if (!theDirective) {
      return;
    }

    this.fusePerfectScrollbar = theDirective;

    this.navigationServiceWatcher =
      this.navigationService.onItemCollapseToggled.subscribe(() => {
        this.fusePerfectScrollbarUpdateTimeout = setTimeout(() => {
          this.fusePerfectScrollbar.update();
        }, 310);
      });
  }

  @Input() public layout: 'vertical' | 'horizontal';
  @Input() public navigation: any;
  public readonly themeMode$ = this.smartMoveTheme.mode$;
  private navigationServiceWatcher: Subscription;
  private fusePerfectScrollbarUpdateTimeout: NodeJS.Timeout;

  constructor(
    private sidebarService: FuseSidebarService,
    private navigationService: FuseNavigationService,
    public sharedService: SharedService,
    private smartMoveTheme: SmartMoveThemeService
  ) {
    this.layout = 'vertical';
  }

  get activeNavigation(): any {
    return this.navigation || this.sharedService.navigation;
  }

  ngOnDestroy(): void {
    if (this.fusePerfectScrollbarUpdateTimeout) {
      clearTimeout(this.fusePerfectScrollbarUpdateTimeout);
    }

    if (this.navigationServiceWatcher) {
      this.navigationServiceWatcher.unsubscribe();
    }
  }

  toggleSidebarOpened(key: string): void {
    this.sidebarService.getSidebar(key).toggleOpen();
  }

  toggleSidebarFolded(key: string): void {
    this.sidebarService.getSidebar(key).toggleFold();
  }
}
